/**
 * ============================================================================
 * GLOBETROTTER ARTISAN INDIA — GLOBAL CLIENT SCRIPT
 * Phase 2: Accessible Navigation, Mobile Drawer & Header Interactions
 * ============================================================================
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
    initStickyHeader();
    initDesktopDropdowns();
    initBackToTop();
    initRfqPrefill();
  });

  /**
   * 1. Accessible Mobile Navigation Drawer
   */
  function initMobileDrawer() {
    var toggleBtn = document.querySelector('[data-gtai-drawer-trigger]');
    var closeBtn = document.querySelector('[data-gtai-drawer-close]');
    var drawer = document.getElementById('MobileNavDrawer');
    var overlay = document.querySelector('[data-gtai-drawer-overlay]');

    if (!toggleBtn || !drawer || !overlay) return;

    var focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-active');
      document.documentElement.classList.add('gtai-drawer-open');
      document.body.classList.add('gtai-drawer-open');

      toggleBtn.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');

      // Focus first focusable element inside drawer
      var focusableElements = drawer.querySelectorAll(focusableSelectors);
      if (focusableElements.length > 0) {
        setTimeout(function () {
          focusableElements[0].focus();
        }, 50);
      }

      document.addEventListener('keydown', handleKeyDown);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-active');
      document.documentElement.classList.remove('gtai-drawer-open');
      document.body.classList.remove('gtai-drawer-open');

      toggleBtn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');

      document.removeEventListener('keydown', handleKeyDown);

      // Return focus to trigger button
      toggleBtn.focus();
    }

    function handleKeyDown(e) {
      // Escape key closes drawer
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeDrawer();
        return;
      }

      // Tab trap inside drawer
      if (e.key === 'Tab' || e.keyCode === 9) {
        var focusableElements = drawer.querySelectorAll(focusableSelectors);
        if (focusableElements.length === 0) return;

        var firstElement = focusableElements[0];
        var lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    }

    toggleBtn.addEventListener('click', function () {
      var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    overlay.addEventListener('click', closeDrawer);

    // Mobile accordion toggles
    var accordionToggles = drawer.querySelectorAll('[data-gtai-accordion-toggle]');
    accordionToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = btn.getAttribute('data-gtai-accordion-target');
        var targetSublist = document.getElementById(targetId);
        if (!targetSublist) return;

        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', (!isExpanded).toString());

        if (isExpanded) {
          targetSublist.classList.remove('is-expanded');
        } else {
          targetSublist.classList.add('is-expanded');
        }
      });
    });
  }

  /**
   * 2. Header Scroll Observer & Announcement Bar Measurement
   */
  function initStickyHeader() {
    var headerWrapper = document.querySelector('.gtai-header-wrapper');
    var announcementBar = document.querySelector('.gtai-announcement-bar');
    if (!headerWrapper) return;

    function updateAnnouncementHeight() {
      var height = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
    }

    // Measure on init, resize, and window load
    updateAnnouncementHeight();
    window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
    window.addEventListener('load', updateAnnouncementHeight, { passive: true });

    var ticking = false;

    function onScroll() {
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      var threshold = announcementBar ? announcementBar.offsetHeight : 20;

      if (currentScroll > threshold) {
        headerWrapper.classList.add('is-scrolled');
      } else {
        headerWrapper.classList.remove('is-scrolled');
      }

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    // Initial check on load
    onScroll();
  }

  /**
   * 3. Desktop Dropdown Keyboard Support
   */
  function initDesktopDropdowns() {
    var dropdownItems = document.querySelectorAll('.gtai-nav__item:has(.gtai-dropdown)');

    dropdownItems.forEach(function (item) {
      var link = item.querySelector('.gtai-nav__link');
      var dropdown = item.querySelector('.gtai-dropdown');
      if (!link || !dropdown) return;

      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.keyCode === 40) {
          e.preventDefault();
          dropdown.classList.add('is-open');
          var firstSublink = dropdown.querySelector('a');
          if (firstSublink) firstSublink.focus();
        }
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          dropdown.classList.remove('is-open');
          link.focus();
        }
      });

      item.addEventListener('mouseleave', function () {
        dropdown.classList.remove('is-open');
      });
    });
  }

  /**
   * 4. Back To Top
   */
  function initBackToTop() {
    var backToTopBtn = document.querySelector('[data-gtai-back-to-top]');
    if (!backToTopBtn) return;

    backToTopBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      var mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();
      }
    });
  }

  /**
   * 5. RFQ / Request Pricing SKU Query Param Prefill
   */
  function initRfqPrefill() {
    var skuField = document.getElementById('gtai-rfq-sku-field');
    if (!skuField) return;

    try {
      var params = new URLSearchParams(window.location.search);
      var skuParam = params.get('sku');
      if (skuParam && !skuField.value) {
        skuField.value = decodeURIComponent(skuParam);
      }
    } catch (e) {
      // Graceful fallback for older browsers
    }
  }
})();
